import script from "./MemberInvalid.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberInvalid.vue?vue&type=script&setup=true&lang=ts"

import "./MemberInvalid.vue?vue&type=style&index=0&id=2f757009&lang=scss"

const __exports__ = script;

export default __exports__